<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin, BTable, BOverlay,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import axios from '@axios';
import { required, email } from '@validations';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import TabClassifiscFiscal from '@/views/cadastros-gerais/tipo-pedido-estab/list/TabClassifiscFiscal.vue';
import TabOrigem from '@/views/cadastros-gerais/tipo-pedido-estab/list/TabOrigem.vue';
import TabDestino from '@/views/cadastros-gerais/tipo-pedido-estab/list/TabDestino.vue';
import SLSTipoPedidoEstabClassifiscService from '@/services/SistemaDKP/SLSTipoPedidoEstabClassifisc.service';
import { ref } from '@vue/composition-api';
import useList from '@/views/cadastros-gerais/tipo-pedido-estab/list/useList';
import { avatarText } from '@core/utils/filter';

export default {
  components: {
    TabClassifiscFiscal,
    TabOrigem,
    TabDestino,
    BTable,
    BOverlay,
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        tipopedidoid: '',
        estabelecimentoid: '',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    tipo: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  data() {
    return {
      dataFromApi: null,
      dataFromApiTipoPedido: null,
      dataFromApiEstabelecimento: null,
      isLoadingData: false,
      isSaving: false,
    };
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async validateForm() {
      this.$emit('ok', this.dataForm);
      this.$bvModal.hide(this.idModal);
    },
    async closeModal() {
      this.$bvModal.hide(this.idModal);
    },
    async fetchDataFromNaturezaOperacao() {
      try {
        const response = await axios.get('/natureza-operacao');
        this.dataFromApi = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async fetchDataFromTipoPedido() {
      try {
        const response = await axios.get('/tipo-pedido');
        this.dataFromApiTipoPedido = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async fetchDataFromEstabelecimento() {
      try {
        const response = await axios.get('/estabelecimento');
        this.dataFromApiEstabelecimento = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async onModalShow() {
      this.isLoadingData = true;
      try {
        await Promise.all([
          this.fetchDataFromNaturezaOperacao(),
          this.fetchDataFromTipoPedido(),
          this.fetchDataFromEstabelecimento(),
        ]);
      } finally {
        this.isLoadingData = false;
      }
    },
    async handleUpdate(body) {
      this.isSaving = true;
      console.log('Dados a serem atualizados:', body);
      console.log('loading', this.isSaving);
      try {
        const response = await this.Updated(body);
        if (response && response.status >= 200 && response.status < 300) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso',
              text: 'Alterações salvas com sucesso!',
              icon: 'CheckIcon',
              variant: 'success',
            },
          });
          this.closeModal();
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro',
              text: 'Não foi possível salvar as alterações.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Ocorreu um erro ao salvar as alterações.',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.isSaving = false;
        this.$bvModal.hide(this.idModal);
      }
    },
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === this.idModal) {
        this.onModalShow();
      }
    });
  },
  beforeDestroy() {
    this.$root.$off('bv::modal::show');
  },
  setup() {
    const {
      Updated,
      create,
      removerData,
    } = useList();

    return {
      Updated,
      create,
      removerData,
    };
  },
};
</script>

<template>
  <b-modal
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
      :id="idModal"
      :title="titleModal"
      cancel-variant="secondary"
      body-bg-variant="light"
      cancel-title="Cancelar"
      ok-variant="false"
      custom-footer
      @cancel="$emit('cancel')"
      @close="$emit('cancel')"
  >
    <template #modal-footer>
      <b-button variant="secondary" @click="closeModal">Fechar</b-button>
    </template>

    <b-overlay :show="isLoadingData" rounded="sm">
      <validation-observer ref="refFormData">
        <b-tabs content-class="mt-2" justified>
          <b-tab active title="Estabelecimento">
            <b-overlay :show="isSaving" rounded="sm">
              <b-form @submit.prevent>
                <b-row>
                  <b-col
                      cols="6"
                      class="mb-0"
                  >
                    <b-form-group
                        label="Tipo Pedido"
                        label-for="tipopedidoid"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Descrição"
                          rules="required"
                      >
                        <b-form-input
                            v-model="dataForm.tipopedidodescricao"
                            id="tipopedidoid"
                            :state="errors.length > 0 ? false : null"
                            placeholder="Digite o id"
                            disabled
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                      cols="6"
                      class="mb-1"
                  >
                    <b-form-group
                        label="Estabelecimento"
                        label-for="estabelecimentoid"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Descrição"
                          rules="required"
                      >
                        <b-form-input
                            v-model="dataForm.estabelecimentorazaosocial"
                            id="estabelecimentoid"
                            :state="errors.length > 0 ? false : null"
                            placeholder="Digite o id"
                            disabled
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                      cols="6"
                      class="mb-1"
                  >
                    <b-form-group
                        label="Nat Oper Estadual (Indústria)"
                        label-for="tipopedidoestabnatopestadual"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Nat Oper Estadual (Indústria)"
                          rules="required"
                      >
                        <b-form-select
                            v-model="dataForm.tipopedidoestabnatopestadual"
                            id="tipopedidoestabnatopestadual"
                            :state="errors.length > 0 ? false : null"
                            :options="dataFromApi"
                            value-field="naturezaoperacaoid"
                            text-field="naturezaoperacaodescricao"
                            placeholder="Selecione um estabelecimento"
                            :disabled="dataForm.isDefault"
                        />

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                      cols="6"
                      class="mb-1"
                  >
                    <b-form-group
                        label="Nat Oper Interestadual (Indústria)"
                        label-for="tipopedidoestabnatopinterest"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Nat Oper Interestadual (Indústria)"
                          rules="required"
                      >
                        <b-form-select
                            v-model="dataForm.tipopedidoestabnatopinterest"
                            id="tipopedidoestabnatopinterest"
                            :state="errors.length > 0 ? false : null"
                            :options="dataFromApi"
                            value-field="naturezaoperacaoid"
                            text-field="naturezaoperacaodescricao"
                            placeholder="Selecione um estabelecimento"
                            :disabled="dataForm.isDefault"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                      cols="6"
                      class="mb-1"
                  >
                    <b-form-group
                        label="Nat Oper Estadual (Revenda)"
                        label-for="tipopedidoestabnatopestrang"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Nat Oper Estadual (Revenda)"
                          rules="required"
                      >
                        <b-form-select
                            v-model="dataForm.tipopedidoestabnatopestrang"
                            id="tipopedidoestabnatopestrang"
                            :state="errors.length > 0 ? false : null"
                            :options="dataFromApi"
                            value-field="naturezaoperacaoid"
                            text-field="naturezaoperacaodescricao"
                            placeholder="Selecione um estabelecimento"
                            :disabled="dataForm.isDefault"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                      cols="6"
                      class="mb-1"
                  >
                    <b-form-group
                        label="Nat Oper Interestadual (Revenda)"
                        label-for="tipopedidoestabnatopncestadual"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Nat Oper Interestadual (Revenda)"
                          rules="required"
                      >
                        <b-form-select
                            v-model="dataForm.tipopedidoestabnatopncestadual"
                            id="tipopedidoestabnatopncestadual"
                            :state="errors.length > 0 ? false : null"
                            :options="dataFromApi"
                            value-field="naturezaoperacaoid"
                            text-field="naturezaoperacaodescricao"
                            placeholder="Selecione um estabelecimento"
                            :disabled="dataForm.isDefault"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                      cols="6"
                      class="mb-1"
                  >
                    <b-form-group
                        label="Nat Oper Estadual (Cons.Final/Rural)"
                        label-for="tipopedidoestabnatopncinterest"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Nat Oper Estadual (Cons.Final/Rural)"
                          rules="required"
                      >
                        <b-form-select
                            v-model="dataForm.tipopedidoestabnatopncinterest"
                            id="tipopedidoestabnatopncinterest"
                            :state="errors.length > 0 ? false : null"
                            :options="dataFromApi"
                            value-field="naturezaoperacaoid"
                            text-field="naturezaoperacaodescricao"
                            placeholder="Selecione um estabelecimento"
                            :disabled="dataForm.isDefault"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                      cols="6"
                      class="mb-1"
                  >
                    <b-form-group
                        label="Nat Oper Interestadual (Cons.Final/Rural)"
                        label-for="tipopedidoestabnatopzf"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Nat Oper Interestadual (Cons.Final/Rural)"
                          rules="required"
                      >
                        <b-form-select
                            v-model="dataForm.tipopedidoestabnatopzf"
                            id="tipopedidoestabnatopzf"
                            :state="errors.length > 0 ? false : null"
                            :options="dataFromApi"
                            value-field="naturezaoperacaoid"
                            text-field="naturezaoperacaodescricao"
                            placeholder="Selecione um estabelecimento"
                            :disabled="dataForm.isDefault"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                      cols="6"
                      class="mb-1"
                  >
                    <b-form-group
                        label="Nat Oper Estadual (Não Contribuinte)"
                        label-for="tipopedidoestabnatopimportado"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Nat Oper Estadual (Não Contribuinte)"
                          rules="required"
                      >
                        <b-form-select
                            v-model="dataForm.tipopedidoestabnatopimportado"
                            id="tipopedidoestabnatopimportado"
                            :state="errors.length > 0 ? false : null"
                            :options="dataFromApi"
                            value-field="naturezaoperacaoid"
                            text-field="naturezaoperacaodescricao"
                            placeholder="Selecione um estabelecimento"
                            :disabled="dataForm.isDefault"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                      cols="6"
                      class="mb-1"
                  >
                    <b-form-group
                        label="Nat Oper Interestadual (Não Contribuinte)"
                        label-for="tipopedidoestabnatopcfestadual"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Nat Oper Interestadual (Não Contribuinte)"
                          rules="required"
                      >
                        <b-form-select
                            v-model="dataForm.tipopedidoestabnatopcfestadual"
                            id="tipopedidoestabnatopcfestadual"
                            :state="errors.length > 0 ? false : null"
                            :options="dataFromApi"
                            value-field="naturezaoperacaoid"
                            text-field="naturezaoperacaodescricao"
                            placeholder="Selecione um estabelecimento"
                            :disabled="dataForm.isDefault"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                      cols="6"
                      class="mb-1"
                  >
                    <b-form-group
                        label="Nat Oper (Estrangeira)"
                        label-for="tipopedidoestabnatopcfinterest"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Nat Oper (Estrangeira)"
                          rules="required"
                      >
                        <b-form-select
                            v-model="dataForm.tipopedidoestabnatopcfinterest"
                            id="tipopedidoestabnatopcfinterest"
                            :state="errors.length > 0 ? false : null"
                            :options="dataFromApi"
                            value-field="naturezaoperacaoid"
                            text-field="naturezaoperacaodescricao"
                            placeholder="Selecione um estabelecimento"
                            :disabled="dataForm.isDefault"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                      cols="6"
                      class="mb-1"
                  >
                    <b-form-group
                        label="Nat Oper (Zona Franca)"
                        label-for="tipopedidoestabnatoprvestadual"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Nat Oper (Zona Franca)"
                          rules="required"
                      >
                        <b-form-select
                            v-model="dataForm.tipopedidoestabnatoprvestadual"
                            id="tipopedidoestabnatoprvestadual"
                            :state="errors.length > 0 ? false : null"
                            :options="dataFromApi"
                            value-field="naturezaoperacaoid"
                            text-field="naturezaoperacaodescricao"
                            placeholder="Selecione um estabelecimento"
                            :disabled="dataForm.isDefault"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                      cols="6"
                      class="mb-1"
                  >
                    <b-form-group
                        label="Nat Oper (Área Livre Comércio)"
                        label-for="tipopedidoestabnatoprvinterest"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Nat Oper (Área Livre Comércio)"
                          rules="required"
                      >
                        <b-form-select
                            v-model="dataForm.tipopedidoestabnatoprvinterest"
                            id="tipopedidoestabnatoprvinterest"
                            :state="errors.length > 0 ? false : null"
                            :options="dataFromApi"
                            value-field="naturezaoperacaoid"
                            text-field="naturezaoperacaodescricao"
                            placeholder="Selecione um estabelecimento"
                            :disabled="dataForm.isDefault"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                      cols="6"
                      class="mb-1"
                  >
                    <b-form-group
                        label="Nat Oper (Produto Importado)"
                        label-for="tipopedidoestabnatopareaolivrecom"
                    >
                      <validation-provider
                          #default="{ errors }"
                          name="Nat Oper (Produto Importado)"
                          rules="required"
                      >
                        <b-form-select
                            v-model="dataForm.tipopedidoestabnatopareaolivrecom"
                            id="tipopedidoestabnatopareaolivrecom"
                            :state="errors.length > 0 ? false : null"
                            :options="dataFromApi"
                            value-field="naturezaoperacaoid"
                            text-field="naturezaoperacaodescricao"
                            placeholder="Selecione um estabelecimento"
                            :disabled="dataForm.isDefault"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
              <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="success"
                  @click="handleUpdate(dataForm)"

              >
                Salvar Alterações
              </b-button>
            </b-overlay>
          </b-tab>
          <b-tab title="Classificação Fiscal">
            <TabClassifiscFiscal
            :value="value"/>
          </b-tab>
          <b-tab title="Origem">
            <TabOrigem
                :value="value"/>
          </b-tab>
          <b-tab title="Destino">
            <TabDestino
                :value="value"/>
          </b-tab>
        </b-tabs>
      </validation-observer>
    </b-overlay>
  </b-modal>
</template>
